import { ApisauceInstance } from 'apisauce';

// FleetOps staff approve the permitted groups, so the customer can activate
const postApprove = async (api: ApisauceInstance): Promise<boolean> => {
  const response = await api.post('/v1/sso/microsoft/approve', {});
  return response.ok;
};

export default postApprove;
